import './mail-transfer-workspace.ajscss';

import { IAgentConfigDeprecatedService } from '@agent/core/agent/agent-config-deprecated.service';
import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { IEpticaRequestFrame } from '@agent/core/channel-digit/mail/eptica/models/eptica.request.interfaces';
import { isEmailValid } from '@agent/core/channel-digit/mail/util/mail-util';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import {
  ITransfer,
  TransferHistorySelectionStatus,
  TransferKey,
  TransferTarget,
  TransferType,
} from '@agent/core/contact/transfer/models/transfer';
import { ITransferDeprecatedService } from '@agent/core/contact/transfer/transfer-deprecated.service';
import { IDirectoryService } from '@agent/core/search/directory.service';
import { ISearchService } from '@agent/core/search/search.service';
import { SessionDeprecatedService } from '@commons/core/auth/session-deprecated.service';
import {
  IEpticaExctractAttachment,
  IEpticaExtractAttachmentAction,
  IEpticaExtractAttachmentFrom,
} from '@commons/history/history-mail/models/eptica-extract';
import { ChannelUtil } from '@commons/util/helper/channel';
import { copy, IComponentController, IComponentOptions, IPromise, isString } from 'angular';
import { i18n } from 'i18next';
import moment from 'moment';
import { BehaviorSubject, debounceTime, throwIfEmpty } from 'rxjs';

import {
  AppConf,
  ChannelDirection,
  ChannelType,
  EpticaService,
  extractEpticaField,
  Group,
  isNotNullOrUndefined,
  LoaderDeprecatedService,
  MediaType,
  MomentService,
  ProfileFacade,
  Skill,
  Team,
  ToasterFacade,
} from '@contact/upgrade';

import templateUrl from './mail-transfer-workspace.template.html';
import { ng1Destroy } from '@commons/util/utilities/rx';

const LOADER_TARGET_ELT_ID = 'Area-WorkZone-Core';

export class MailTransferWorkspaceCtrl implements IComponentController {
  responseId: string;
  requestId: string;
  hasOwiSkill: boolean = false;

  availableSkills: Skill[] = [];
  teams: any[] = [];
  originalTeams: any[] = [];
  groups: any[] = [];
  originalgroups: any[] = [];
  originalCsrs: any[] = [];
  candidateCsrs: any[];
  lastfilter = '';
  noResultsTeamTarget: boolean = false;
  isFreeMailTransferEnabled: boolean = true;
  skillsFilter: any[] = [];
  availableTeams: any[] = [];
  maxCommentChars = 255;

  availableTargetTypes: TransferTarget[] = [];
  _selectedTeam: Team | undefined = undefined;
  _selectedGroup: Group | undefined = undefined;
  protected contactSkillNames: string[] = [];
  protected transferKey: TransferKey;
  private requestPromise: IPromise<IEpticaRequestFrame>;
  _selectedSkills: Skill[] = [];
  public allAttachments: IEpticaExctractAttachment[] = [];
  _visibleDomainUuids: string[] = [];

  protected fromType: IEpticaExtractAttachmentFrom = IEpticaExtractAttachmentFrom.TRANSFER;

  public valid: boolean = true;
  public isSkillsPrefillParamDefine: boolean = false;

  protected readonly _agentChosen$ = new BehaviorSubject<string>('');
  readonly agentChosen$ = this._agentChosen$.asObservable();

  // binding
  public eventTargetChange: Function;

  constructor(
    protected readonly $i18next: i18n,
    protected readonly sessionDeprecatedService: SessionDeprecatedService,
    protected readonly appConf: AppConf,
    protected readonly agentConfigDeprecatedService: IAgentConfigDeprecatedService,
    protected readonly contactDeprecatedService: IContactDeprecatedService,
    protected readonly epticaDeprecatedService: IEpticaDeprecatedService,
    protected readonly transferDeprecatedService: ITransferDeprecatedService,
    protected readonly search: ISearchService,
    protected readonly directoryService: IDirectoryService,
    protected readonly timeUtil: MomentService,
    protected readonly loaderDeprecatedService: LoaderDeprecatedService,
    protected readonly epticaService: EpticaService,
    protected readonly toasterFacade: ToasterFacade,
    protected readonly profileFacade: ProfileFacade
  ) {}

  get selectedSkills(): Skill[] {
    this.transfer.target = this._selectedSkills;
    return this._selectedSkills;
  }

  set selectedSkills(selectedSkills: Skill[]) {
    this.transfer.target = this._selectedSkills;
    this._selectedSkills = selectedSkills;
  }

  get transfer(): ITransfer {
    return this.transferDeprecatedService.getTransfer(this.transferKey).getOrElseFunc(() => {
      let transf = this.transferDeprecatedService.createTransfer(this.transferKey, ChannelUtil.INCOMING_MAIL);
      transf.targetType = TransferTarget.COMPOSITE;
      return transf;
    });
  }

  get emailValid(): boolean {
    return isEmailValid(this.transfer.target);
  }

  onTargetMailChange(): void {
    this.valid = this.emailValid;
    if (this.valid) {
      this.eventTargetChange({ $event: { target: this.transfer.target } });
    } else {
      this.eventTargetChange({ $event: { target: undefined } });
    }
  }

  public commonInit() {
    this.requestPromise = this.contactDeprecatedService.getContact(this.responseId).then(contact => {
      this.requestId = `${contact.epticaRequestId || 0}`;
      this.transferKey = [this.requestId];
      return this.epticaDeprecatedService.loadRequest({
        requestId: contact.epticaRequestId || 0,
        responseId: this.responseId,
      });
    });

    this.initAvailableTypes();

    this.transferDeprecatedService.getAvailableSkills(this.responseId, true).then(skills => {
      (skills as any[]).forEach(s => {
        s.cssClass = '';
      });
      this.availableSkills = [...skills].sort((a, b) => {
        if (a.name.toLowerCase() > b.name.toLowerCase()) {
          return 1;
        }
        if (a.name.toLowerCase() < b.name.toLowerCase()) {
          return -1;
        }
        return 0;
      });
    });

    this.agentConfigDeprecatedService.domainTeams.forEach(team => {
      this.teams.push({
        id: team.id,
        name: team.name,
        type: 'team',
      });
    });

    this.originalTeams = copy(this.teams);

    this.agentConfigDeprecatedService.domainGroups.forEach(group => {
      this.groups.push({
        id: group.id,
        name: group.name,
        type: 'group',
      });
    });

    this.originalgroups = copy(this.groups);

    this.contactDeprecatedService.getContact(this.responseId).then(contact => {
      contact.skills.forEach(skillName => this.contactSkillNames.push(skillName));
    });

    this._agentChosen$.pipe(debounceTime(500)).subscribe(csrPrefix => this.updateCandicateCsrList(csrPrefix));
    this.profileFacade.profile$.subscribe(profile => (this._visibleDomainUuids = profile.accessibleDomainUuids));

    this.updateCandicateCsrList();
    this.onTargetChange();
  }

  $onInit(): void {
    this.appConf.pipe(ng1Destroy(this)).subscribe(({ keepSkillsDuringTransfert, mail }) => {
      this.isSkillsPrefillParamDefine = keepSkillsDuringTransfert !== null && keepSkillsDuringTransfert !== undefined;

      // Math.min function ensures that maxCommentChars will not exceed 1000, even if MAIL_COMMENT_MAX_CHARS is greater than 1000
      this.maxCommentChars = Math.min(mail?.maxCommentChars || 255, 1000);
      this.isFreeMailTransferEnabled = !mail?.isFreeMailTransferDisabled;
    });

    this.commonInit();

    this.mainPromise().then(request => {
      request.selectAllMessageRequestHistory();

      // do we display the knowledgeBase notification checkbox ?
      if (this.sessionDeprecatedService.hasPermission('CSR::bad_request_routing:report')) {
        this.epticaService
          .getRequest(request.getId())
          .pipe(isNotNullOrUndefined(), throwIfEmpty())
          .subscribe(rq => (this.hasOwiSkill = extractEpticaField(rq, 'awlOwiSkill') !== ''));
      }

      // manage Pjs' events
      request.addPJEventsForDelegate(this.mainCallbackAttachmentFiles);
    });
  }

  // callback called by the eptica's dropzone
  public mainCallbackAttachmentFiles = (file: IEpticaExctractAttachment): void => {
    if (!!file) {
      file.fromType = this.fromType;
      if (file.action === IEpticaExtractAttachmentAction.ADDED || file.action === IEpticaExtractAttachmentAction.ADDED_BY_DRAFT_LOADING) {
        let updated = false;
        // update the file if already exists
        this.mainAttachmentFiles()
          .filter(elem => elem.file === file.file)
          .forEach(elem => {
            if (!!file.file) {
              elem.file = file.file;
            }
            if (!!file.source) {
              elem.source = file.source;
            }
            updated = true;
          });
        // add the file to the component
        if (!updated) {
          this.mainAttachmentFiles().push(file);
          // add the file in the files saved attachment in service
          if (file.fromType === IEpticaExtractAttachmentFrom.ASK_FOR_HELP || file.fromType === IEpticaExtractAttachmentFrom.TRANSFER) {
            this.epticaDeprecatedService.addAttachment(this.requestId, file);
          }
        }
      } else if (file.action === IEpticaExtractAttachmentAction.REMOVED) {
        // remove the file from the component
        this.setMainAttachmentFiles(this.mainAttachmentFiles().filter(elem => elem.file !== file.file));
        // only in case of ask for help
        // remove the file from saved attachment in service
        if (file.fromType === IEpticaExtractAttachmentFrom.ASK_FOR_HELP || file.fromType === IEpticaExtractAttachmentFrom.TRANSFER) {
          this.epticaDeprecatedService.removeAttachment(this.requestId, file);
        }
      }
    }
  };

  initAvailableTypes(): void {
    this.availableTargetTypes.push(TransferTarget.COMPOSITE);
    this.availableTargetTypes.push(TransferTarget.SKILL);
    this.availableTargetTypes.push(TransferTarget.TEAM);
    this.availableTargetTypes.push(TransferTarget.AGENT);
    this.availableTargetTypes.push(TransferTarget.CORRESPONDENT);
    if (this.isFreeMailTransferEnabled) {
      this.availableTargetTypes.push(TransferTarget.FREE_NUMBER);
    }
  }

  $onDestroy(): void {
    this.transfer.targetType = TransferTarget.COMPOSITE;
    this.mainPromise().then(request => {
      request.toggleAnswerPanel(true);
      request.toggleDelegatePanel(false);
      request.removePJEventsDelegate();
      request.hide();
    });
    this._agentChosen$.complete();
  }

  mainPromise(): IPromise<IEpticaRequestFrame> {
    return this.requestPromise;
  }

  mainAttachmentFiles(): IEpticaExctractAttachment[] {
    return this.allAttachments;
  }

  setMainAttachmentFiles(files: IEpticaExctractAttachment[]): IEpticaExctractAttachment[] {
    this.allAttachments = files;
    return this.allAttachments;
  }

  addPeriodOfAbsenceIfExist(csr: any): string {
    const isValidAbsence =
      (this.transfer.targetType === TransferTarget.AGENT || this.transfer.targetType === TransferTarget.SKILL) && !!csr.periodOfAbsence;
    if (isValidAbsence) {
      const absenceFrom =
        this.$i18next.t('agent:contact.workspace.mail.askForHelp.absent_from') + moment(csr.periodOfAbsence.beginDate).format('DD/MM');
      const absenceTo =
        this.$i18next.t('agent:contact.workspace.mail.askForHelp.absent_to') + moment(csr.periodOfAbsence.endDate).format('DD/MM');
      const backup =
        this.$i18next.t('agent:contact.workspace.mail.askForHelp.backup') +
        csr.periodOfAbsence.targetedUserLastName +
        ' ' +
        csr.periodOfAbsence.targetedUserFirstName;
      if (csr.periodOfAbsence.mailTransferType === 'CSR') {
        return `${absenceFrom} ${absenceTo} ${backup}`;
      } else return `${absenceFrom} ${absenceTo}`;
    }
    return '';
  }

  addAbsenceDetailsOnAgent(csr: any): any {
    if (
      moment(csr.periodOfAbsence.beginDate).isBefore() &&
      moment(csr.periodOfAbsence.endDate).isAfter() &&
      csr.periodOfAbsence.activated
    ) {
      csr.absence = true;
      csr.cssClass = 'absence';
      csr.dateAbsence = this.timeUtil.readableDateShort(csr.periodOfAbsence.endDate);
      csr.dateAbsence = csr.dateAbsence.substr(0, csr.dateAbsence.length - 5);
      if (csr.periodOfAbsence.hasOwnProperty('mailTransferType')) {
        if (csr.periodOfAbsence.mailTransferType === 'CSR') {
          csr.backup = csr.periodOfAbsence.targetedUserLastName + ' ' + csr.periodOfAbsence.targetedUserFirstName;
        } else if (csr.periodOfAbsence.mailTransferType === 'SKILLS') {
          let skillList = '';
          this.search.searchSkillByUuid(csr.periodOfAbsence.targetedSkillUuidList).then((skill: any) => {
            skill.data.hits.hits.forEach(element => {
              skillList = `${skillList}${element._source.name} `;
            });
            csr.backup = skillList.trim();
          });
        } else if (csr.periodOfAbsence.mailTransferType === 'TEAM') {
          this.search.searchTeamByUuid(csr.periodOfAbsence.targetedTeamUuid).then((team: any) => {
            team.data.hits.hits.forEach(element => {
              csr.backup = element._source.name;
            });
          });
        }
      }
    }
  }

  getAgentWithFurthestAbsence(csr: any, csrWithFurthestAbsence: any): any {
    if (!csrWithFurthestAbsence) {
      return csr;
    }
    if (moment(csr.periodOfAbsence.beginDate).isSameOrAfter(csrWithFurthestAbsence.periodOfAbsence.beginDate)) {
      return csr;
    }
  }

  setCsrTargetRandomly(candidateCsrs: any[], isCsrWithoutAbsenceExist: boolean, csrWithFurthestAbsence: any) {
    const csrFilteredList = candidateCsrs.filter(c => c.periodOfAbsence === undefined);
    const randomIndex = Math.floor(Math.random() * csrFilteredList.length);
    this.transfer.target = isCsrWithoutAbsenceExist ? csrFilteredList[randomIndex] : csrWithFurthestAbsence;
    this.transfer.target.selected = true;
    this.transfer.target.chosen = true;
    this.transfer.target.displayed = true;
  }

  searchResultsFilterAndSort(
    filter: string,
    selectedTeamId: string,
    selectedGroupId: string,
    selectedSkillIds: string[],
    agentPrefix: string
  ) {
    if (this.lastfilter !== filter) {
      this.candidateCsrs = [];
      let isCsrWithoutAbsenceExist = false;
      let csrWithFurthestAbsence: any;
      const isSkillTargetType: boolean = this.transfer.targetType === TransferTarget.AGENT_ASSISTANCE_BY_SKILL;
      this.activeLoader();
      this.search
        .searchCsr(
          selectedTeamId,
          selectedGroupId,
          selectedSkillIds,
          agentPrefix.toLowerCase(),
          'MAIL_INCOMING',
          true,
          this._visibleDomainUuids
        )
        .then((csrList: any) => {
          const candidateCsrs: any[] = csrList
            .filter(c => c.uuid !== this.sessionDeprecatedService.getProfile().id)
            .map(csr => ({
              name: `${csr.lastName} ${csr.firstName} ${this.addPeriodOfAbsenceIfExist(csr)}`,
              email: csr.mail,
              uuid: csr.uuid,
              periodOfAbsence: csr.periodOfAbsence,
            }));
          candidateCsrs.forEach(csr => {
            if (!!csr.periodOfAbsence) {
              // if period of absence begin date is before now and end date is still not reached
              this.addAbsenceDetailsOnAgent(csr);
              if (!isCsrWithoutAbsenceExist) {
                csrWithFurthestAbsence = this.getAgentWithFurthestAbsence(csr, csrWithFurthestAbsence);
              }
            } else {
              if (!isCsrWithoutAbsenceExist) {
                isCsrWithoutAbsenceExist = true;
              }
            }
          });

          this.candidateCsrs = [...candidateCsrs].sort((a, b) => {
            let nameA = a.name.toUpperCase();
            let nameB = b.name.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          });
          this.originalCsrs = copy(this.candidateCsrs);
          if (this.candidateCsrs.length === 0) {
            this.toasterFacade.alert({ message: 'agent:toast.no_agent_correspond_to_search' });
          } else if (isSkillTargetType) {
            this.setCsrTargetRandomly(this.candidateCsrs, isCsrWithoutAbsenceExist, csrWithFurthestAbsence);
          }
        });
      this.lastfilter = filter;
      this.disposeLoader();
    }
  }

  updateCandidateCsrListBySkill(agentPrefix = ''): void {
    this.transfer.target = null;
    const selectedSkillIds = this.getSelectedSkillIds();
    const filter = `${selectedSkillIds} | ${agentPrefix}`;
    const csrChosenTag = $('div#csrSelectAgentField cng-chosen');
    this.candidateCsrs = [];
    if (!!selectedSkillIds && selectedSkillIds.length > 0) {
      this.searchResultsFilterAndSort(filter, '', '', selectedSkillIds, agentPrefix);
      csrChosenTag.removeClass('noSkillSelected');
    } else {
      this.transfer.target = null;
      this.lastfilter = filter;
      csrChosenTag.addClass('noSkillSelected');
    }
  }

  updateCandicateCsrList(agentPrefix = ''): void {
    const filter = `${this.getSelectedTeamId()} | ${this.getSelectedGroupId()} | ${this.getSelectedSkillIds()} | ${agentPrefix}`;
    this.searchResultsFilterAndSort(filter, this.getSelectedTeamId(), this.getSelectedGroupId(), this.getSelectedSkillIds(), agentPrefix);
  }

  private filterWithNormalizedContains(originalList: any[], inputId: string): any[] {
    let input: HTMLInputElement = document.getElementById(inputId) as HTMLInputElement;
    let inputVal = '';
    if (input) {
      inputVal = input.value || '';
    }
    // if input is empty return all elements
    if (inputVal === '') {
      // clone original list and return it
      return [...originalList];
    }
    // else we will filter without being case or accent sensitive
    return originalList.filter(_item => {
      // remove accented characters from search and compare with normalized collection item too
      const itemNameNormalized = this.search.normalize(_item.name);
      const inputValueNormalized = this.search.normalize(inputVal);
      return itemNameNormalized.indexOf(inputValueNormalized) >= 0;
    });
  }

  onCsrTeamChange(): void {
    this.teams = this.filterWithNormalizedContains(this.originalTeams, 'popupCsrTeamSelection');
  }

  onCsrGroupChange(): void {
    this.groups = this.filterWithNormalizedContains(this.originalgroups, 'popupCsrGroupSelection');
  }

  onTargetTeamOrGroupChange(): void {}

  onCsrChange(): void {
    this._agentChosen$.next(this.getAgentAutocompleteText());
  }

  getSelectedTeamId() {
    return this._selectedTeam && this._selectedTeam.id ? this._selectedTeam.id : '';
  }

  getSelectedSkillIds() {
    return this._selectedSkills.map(skill => skill.id);
  }

  getSelectedGroupId() {
    return this._selectedGroup && this._selectedGroup.id ? this._selectedGroup.id : '';
  }

  getAgentAutocompleteText(): string {
    let input: HTMLInputElement = document.getElementById('agentSelection') as HTMLInputElement;
    if (input) return input.value || '';
    return '';
  }

  onTargetChange(): void {
    this.transfer.target = null;
    // prefill contacts skill
    if (this.transfer.targetType === TransferTarget.TEAM && this.isSkillsPrefillParamDefine) {
      this.prefillContactSkills();
    }
    this.updateHistorySelectionStatus();
  }

  onCompositeChanged(eventData: { transfer: ITransfer | null }): void {
    const transferChanged = eventData.transfer;
    if (transferChanged) {
      // Enable history selection when the composite target field is not empty and the target is an email address, a contact or a correspondant directory
      if (
        transferChanged.target &&
        (isString(transferChanged.target) ||
          transferChanged.target.type == TransferType.CONTACT ||
          transferChanged.target.type == TransferType.DIRECTORY)
      ) {
        this.transferDeprecatedService.updateHistorySelectionAbility(TransferHistorySelectionStatus.SELECTABLE);
      } else {
        this.transferDeprecatedService.updateHistorySelectionAbility(TransferHistorySelectionStatus.DISABLED);
      }
    }
  }

  updateHistorySelectionStatus(): void {
    switch (this.transfer.targetType) {
      case TransferTarget.CORRESPONDENT:
      case TransferTarget.FREE_NUMBER:
        this.transferDeprecatedService.updateHistorySelectionAbility(TransferHistorySelectionStatus.SELECTABLE);
        break;
      default:
        this.transferDeprecatedService.updateHistorySelectionAbility(TransferHistorySelectionStatus.DISABLED);
    }
  }

  prefillContactSkills(): void {
    this.skillsFilter = this.availableSkills
      .filter(skill => this.contactSkillNames.indexOf(skill.name) !== -1)
      .map((selected: any) => {
        selected.chosen = true;
        selected.selected = true;
        return selected;
      });
  }

  resetTeamSkills(): void {
    // we reset chosen flags before removing from selected elements
    this.skillsFilter.forEach(s => {
      s.chosen = false;
      s.selected = false;
    });
    this.skillsFilter = [];
    this.transfer.target = null;
  }

  getTargetLabel(target: TransferTarget): string {
    let targetKey = TransferTarget[target].toLowerCase() + '_target';
    return this.$i18next.t('agent:contact.workspace.mail.transfer.' + targetKey);
  }

  getCorrespondents(text?: string): IPromise<any> {
    let groupsFilter = this.agentConfigDeprecatedService.domainGroups;
    return this.directoryService
      .getExternalCorrespondents(
        this.sessionDeprecatedService.getProfile().domainId,
        groupsFilter,
        this.agentConfigDeprecatedService.agentTeam,
        this.contactSkillNames,
        text,
        [MediaType.MAIL]
      )
      .then(success =>
        success.data.map((external: any) => ({
          id: external.uuid,
          name: `${external.lastName.toUpperCase()} ${external.firstName} (${external.email})`,
          directoryName: external.directory.name + (external.category && external.category.name ? `../${external.category.name}` : ''),
          phoneNumber: external.phoneNumber,
          email: external.email,
        }))
      );
  }

  updateCandicateTeamList(): void {
    this.transfer.target = null;
    this.noResultsTeamTarget = false;
    this.availableTeams = [];

    this.directoryService
      .getInternalCorrespondentsWithTeam(this.sessionDeprecatedService.getProfile().domainId, this.skillsFilter, '', {
        type: ChannelType.MAIL,
        direction: ChannelDirection.INCOMING,
      })
      .then(success => {
        if (success.data.length !== 0) {
          let teamMap = {};
          let tmpArray: any[] = [];
          success.data
            .map((agent: any): any => ({
              id: agent.teams[0].uuid,
              name: agent.teams[0].name,
              type: 'team',
              skills: this.skillsFilter,
            }))
            .map(t => {
              if (!teamMap.hasOwnProperty(t.id)) {
                teamMap[t.id] = true;
                tmpArray.push(t);
              }
            });
          this.availableTeams = [...tmpArray].sort((a, b) => {
            if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
            if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
            return 0;
          });
        } else {
          this.noResultsTeamTarget = true;
          this.availableTeams = [];
        }
      });
  }

  private activeLoader() {
    this.loaderDeprecatedService.active(LOADER_TARGET_ELT_ID);
  }

  private disposeLoader() {
    this.loaderDeprecatedService.dispose(LOADER_TARGET_ELT_ID);
  }

  // Open the Eptica dropzone
  addPjs(): void {
    this.mainPromise().then(request => {
      request.simulateClickOnUploadDelegate();
    });
  }

  // send remove order to Eptica's dropzone
  doRemoveLinkCallback(file: IEpticaExctractAttachment): void {
    this.mainPromise().then(request => {
      // manage Pjs' events
      request.removeAttachmentFileForDelegate(file);
    });
  }
}

export class MailTransferWorkspace implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
    eventTargetChange: '&',
  };
  controller = [
    '$i18next',
    'sessionDeprecatedService',
    'appConf',
    'agentConfigDeprecatedService',
    'contactDeprecatedService',
    'epticaDeprecatedService',
    'transferDeprecatedService',
    'search',
    'directory',
    'momentService',
    'loaderDeprecatedService',
    'epticaService',
    'toasterFacade',
    'profileFacade',
    MailTransferWorkspaceCtrl,
  ];
}

export default 'contactMailTransferWorkspace';
